import { createContext, Dispatch } from 'react'
import { State, Action } from './typings'

export type LocationContextType = { state: State; dispatch: Dispatch<Action> }

export const LocationContext = createContext<LocationContextType>({
  state: {} as State,
  dispatch: () => null,
})
